import Web3 from "web3";
import { EthereumProvider } from "@walletconnect/ethereum-provider";

import { CURRENT_CHAIN_ID, CURRENT_RPC_URL, SwitchChain } from "./useWeb3";
import toast, { Toaster } from "react-hot-toast";
import { PROJECT_ID } from "../config/env";
export const MetamaskWallet = async (e) => {
  try {
    if (window.ethereum) {
      const web3 = new Web3(window.ethereum);
      const CHAIN_ID = CURRENT_CHAIN_ID();
      console.log('CHAIN_ID-----', CHAIN_ID)
      try {
        await window.ethereum.enable().then(async () => {
          const chainId = await web3.eth.getChainId();
          if (parseInt(chainId) != parseInt(CHAIN_ID)) {
            const data = await SwitchChain();
            if (data) {
              //   window.location.reload();
            }
          }
          const accounts = await web3.eth.getAccounts();
          console.log("🚀 ~ awaitwindow.ethereum.enable ~ accounts:", accounts)
          const account = accounts[0].toString();
          console.log("🚀 ~ awaitwindow.ethereum.enable ~ account:", account)
          sessionStorage.setItem("accountInfo", account);
          return web3;
        });
      } catch (e) { }
    }
    // Legacy DApp Browsers
    else if (window.web3) {
      const CHAIN_ID = CURRENT_CHAIN_ID();
      const web3 = new Web3(window.web3.currentProvider);
      const chainId = await web3.eth.getChainId();
      if (parseInt(chainId) != parseInt(CHAIN_ID)) {
        const data = await SwitchChain();
        if (data) {
          //   window.location.reload();
        }
      }
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0].toString();
      sessionStorage.setItem("accountInfo", account);
      return web3;
    }
    // Non-DApp Browsers
    else {
      //alert('No Dapp Supported Wallet Found');

      toast.error(
        `No Dapp Supported Wallet Found !`,

        {
          duration: 2000,
          style: {
            minWidth: "300px",
            minHeight: "55px",
          },
        }
      );
    }
  } catch (e) {
    toast.error(`Error : ${e}`, {
      duration: 2000,
      style: {
        minWidth: "300px",
        minHeight: "55px",
      },
    });
  }
};

export const BinanceWallet = async (e) => {
  try {
    if (window.BinanceChain) {
      const web3 = new Web3(window.BinanceChain);

      try {
        await window.BinanceChain.enable().then(async () => {
          const accounts = await web3.eth.getAccounts();
          const account = accounts[0].toString();

          sessionStorage.setItem("accountInfo", account);

          return web3;
        });
      } catch (e) {
        // User has denied account access to DApp...
      }
    }
    // Legacy DApp Browsers
    else if (window.web3) {
      const web3 = new Web3(window.web3.currentProvider);
      const chainId = await web3.eth.getChainId();

      const accounts = await web3.eth.getAccounts();
      const account = accounts[0].toString();
      sessionStorage.setItem("accountInfo", account);
      return web3;
    }
    // Non-DApp Browsers
    else {
      //alert('No Dapp Supported Wallet Found');

      toast.error(`No Dapp Supported Wallet Found !`, {
        duration: 2000,
        style: {
          minWidth: "300px",
          minHeight: "55px",
        },
      });
    }
  } catch (e) {
    toast.error(`Error : ${e}`, {
      duration: 2000,
      style: {
        minWidth: "300px",
        minHeight: "55px",
      },
    });
  }
};

export const WalletConnect = async (e) => {
  const RPC_URL = CURRENT_RPC_URL();
  const CHAIN_ID = CURRENT_CHAIN_ID();
  //Create WalletConnect Provider
  const provider = await EthereumProvider.init({
    projectId: PROJECT_ID, // required
    chains: [CHAIN_ID], // required
    showQrModal: true, // requires @walletconnect/modal
  });
  await provider.connect();

  const web3 = new Web3(provider);
  const accounts = await provider.request({
    method: "eth_requestAccounts",
  });
  const account = accounts[0].toString();
  sessionStorage.setItem("accountInfo", account);
  localStorage.setItem("wcv2", account);

  return provider;
};





export const getAccount = () => {
  // return localStorage.getItem("accountInfo")? localStorage.getItem("accountInfo"): null;
  return sessionStorage.getItem("accountInfo") ? sessionStorage.getItem("accountInfo") : null;
}
// export const NETWORK_SWITCH = (i) => {

//   localStorage.setItem("CHAIN", i);
//   window.location.reload();
// }
export const getChainId = () => {

  const index = localStorage.getItem("CHAIN");
  return index != null ? index : "0";
}
